var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#085488",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 7.15c0 3.575-2.925 6.5-6.5 6.5S0 10.725 0 7.15 2.925.65 6.5.65c2.535 0 4.745 1.43 5.785 3.575",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87 0.455L12.35 4.29 8.45 3.77",
    transform: "translate(1 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshData);
export default __webpack_public_path__ + "static/media/refresh-data.8dd369e1b397eb2696bc6ea54f43ce23.svg";
export { ForwardRef as ReactComponent };